// src/components/IconButton.tsx
import React from "react";
import clsx from "clsx";
import { A } from "../styles/appleClasses";

type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  "aria-label": string; // required for accessibility
};

export function IconButton({
  className,
  disabled,
  type = "button",
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={clsx(
        A.iconBtn,
        "inline-flex items-center justify-center",
        "focus:outline-none focus:ring-2 focus:ring-appleblueD",
        disabled
          ? "cursor-not-allowed opacity-50"
          : "hover:bg-gray-100 transition",
        className
      )}
      {...props}
    />
  );
}
